import { useUserProgress } from '@/shared/contexts/UserProgress'

export function useWallet() {
  const { wallet } = useUserProgress()

  const points = wallet?.points || 0
  const coins = wallet?.coins || 0

  return {
    wallet,
    points,
    coins
  }
}
